module.exports = __webpack_public_path__ + "static/media/sort_desc.a9e7c656.png";